/**
 * Inject cascadedParamExtractor
 * Get cascaded parameter from a link containing links within its param
 * If location is : 'https://accounts.com/?next=/o/au...?redirect_uri=https://developer.../?next=https://developer.com/'
 * and cascadeList is ['next', 'redirect_uri', 'next']
 *  Return https://developer.com/
 * @example cascadedParamExtractor(['next', 'redirect_uri', 'next']);
 * @ngInject
 */

export default /* @ngInject */ function cascadedParamExtractor($location) {
    return function(cascadeList) {
        if(cascadeList.length < 1) {
            return '';
        }
        //Using URLSearch Params polyfill
        let URLSearchParams = require('url-search-params');

        let anchorTag = document.createElement('a');
        let paramVal = $location.$$search[cascadeList[0]];

        for (let i=1; i<cascadeList.length; i++) {
            anchorTag.href = paramVal;
            paramVal = (new URLSearchParams(anchorTag.search)).get(cascadeList[i]);
        }
        anchorTag.remove();

        return paramVal;
    };
}



// WEBPACK FOOTER //
// ./login/cascaded-param-extractor.js